import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsToolbar = ({ selectedCount, onBulkAction, onExport }) => {
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedPriority, setSelectedPriority] = useState('');
  const [selectedAction, setSelectedAction] = useState('');

  const statusOptions = [
    { value: '', label: 'Status ändern...' },
    { value: 'status-pending', label: 'Neu' },
    { value: 'status-review', label: 'In Prüfung' },
    { value: 'status-assigned', label: 'Zugewiesen' },
    { value: 'status-progress', label: 'In Bearbeitung' },
    { value: 'status-completed', label: 'Abgeschlossen' },
    { value: 'status-cancelled', label: 'Storniert' }
  ];

  const priorityOptions = [
    { value: '', label: 'Priorität ändern...' },
    { value: 'priority-low', label: 'Niedrig' },
    { value: 'priority-normal', label: 'Normal' },
    { value: 'priority-high', label: 'Hoch' },
    { value: 'priority-urgent', label: 'Dringend' }
  ];

  const actionOptions = [
    { value: '', label: 'Aktion wählen...' },
    { value: 'assign', label: 'Techniker zuweisen' },
    { value: 'delete', label: 'Löschen' }
  ];

  const exportOptions = [
    { label: 'PDF Export', icon: 'FileText', action: () => onExport('pdf') },
    { label: 'CSV Export', icon: 'Download', action: () => onExport('csv') },
    { label: 'Excel Export', icon: 'FileSpreadsheet', action: () => onExport('xlsx') }
  ];

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    if (status && selectedCount > 0) {
      onBulkAction(status);
      setSelectedStatus('');
    }
  };

  const handlePriorityChange = (priority) => {
    setSelectedPriority(priority);
    if (priority && selectedCount > 0) {
      onBulkAction(priority);
      setSelectedPriority('');
    }
  };

  const handleActionChange = (action) => {
    setSelectedAction(action);
    if (action && selectedCount > 0) {
      onBulkAction(action);
      setSelectedAction('');
    }
  };

  const handleExport = (format) => {
    onExport(format);
    setShowExportMenu(false);
  };

  if (selectedCount === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-4 mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <Icon name="CheckSquare" size={20} className="text-text-secondary" />
              <span className="text-sm text-text-secondary">
                Wählen Sie Aufträge für Massenaktionen aus
              </span>
            </div>
          </div>
          
          <div className="relative">
            {/* <Button
              variant="outline"
              onClick={() => setShowExportMenu(!showExportMenu)}
            >
              <Icon name="Download" size={16} className="mr-2" />
              Export
              <Icon name="ChevronDown" size={16} className="ml-2" />
            </Button> */}
            
            {showExportMenu && (
              <div className="absolute right-0 top-full mt-1 w-48 bg-popover border border-border rounded-lg shadow-modal z-50">
                {exportOptions.map((option, index) => (
                  <button
                    key={index}
                    onClick={option.action}
                    className="w-full flex items-center px-4 py-3 text-sm text-popover-foreground hover:bg-muted transition-colors duration-150"
                  >
                    <Icon name={option.icon} size={16} className="mr-3" />
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-primary" />
            <span className="font-medium text-text-primary">
              {selectedCount} Auftrag{selectedCount !== 1 ? 'e' : ''} ausgewählt
            </span>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-start lg:items-center space-y-4 lg:space-y-0 lg:space-x-4">
          {/* Status Select */}
          <div className="flex items-center space-x-2">
            <Icon name="Activity" size={16} className="text-text-secondary" />
            <Select
              options={statusOptions}
              value={selectedStatus}
              onChange={handleStatusChange}
              placeholder="Status ändern..."
              className="w-48"
            />
          </div>

          {/* Priority Select */}
          <div className="flex items-center space-x-2">
            <Icon name="AlertTriangle" size={16} className="text-text-secondary" />
            <Select
              options={priorityOptions}
              value={selectedPriority}
              onChange={handlePriorityChange}
              placeholder="Priorität ändern..."
              className="w-48"
            />
          </div>

          {/* Action Select */}
          <div className="flex items-center space-x-2">
            <Icon name="Settings" size={16} className="text-text-secondary" />
            <Select
              options={actionOptions}
              value={selectedAction}
              onChange={handleActionChange}
              placeholder="Aktion wählen..."
              className="w-48"
            />
          </div>
          
          {/* Export Button */}
          <div className="relative">
            {/* <Button
              variant="outline"
              size="sm"
              onClick={() => setShowExportMenu(!showExportMenu)}
            >
              <Icon name="Download" size={16} className="mr-2" />
              Export
              <Icon name="ChevronDown" size={16} className="ml-2" />
            </Button> */}
            
            {showExportMenu && (
              <div className="absolute right-0 top-full mt-1 w-48 bg-popover border border-border rounded-lg shadow-modal z-50">
                {exportOptions.map((option, index) => (
                  <button
                    key={index}
                    onClick={option.action}
                    className="w-full flex items-center px-4 py-3 text-sm text-popover-foreground hover:bg-muted transition-colors duration-150"
                  >
                    <Icon name={option.icon} size={16} className="mr-3" />
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsToolbar;